//don't add any negative values here (not that you normally would) -
//but at least one place checks whether the status <= vehicleStatus <= VehicleStatus.SubmittedForAuctionReview || vehicleStatus === VehicleStatus.SubmittedForBuyNowReview
export const VehicleStatus = {
  Draft: 0,
  SubmittedForAuctionReview: 1,
  RejectedForAuction: 2,
  ApprovedForAuction: 3,
  OnLiveAuction: 4,
  CompletedFromAuction: 5,
  Stopped: 6,
  SubmittedForBuyNowReview: 7,
  ApprovedForBuyNow: 8,
  CompletedFromBuyNow: 9,
  RejectedForBuyNow: 10,
  Deleted: 11,
  SubmittedForCashOffer: 12,
  SentForCashOffer: 13,
  DeclinedByAdminForCashOffer: 14,
  DeclinedBySellerForCashOffer: 15,
  CanceledByAdminForCashOffer: 16,
  CanceledBySellerForCashOffer: 17,
  CompletedFromCashOffer: 18,
  CanceledByExpirationForCashOffer: 19,
}
